import { render, staticRenderFns } from "./CampoRedebanApps.vue?vue&type=template&id=1f10b30b&scoped=true"
import script from "./CampoRedebanApps.vue?vue&type=script&lang=js"
export * from "./CampoRedebanApps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f10b30b",
  null
  
)

export default component.exports